import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, RouterModule, NavigationEnd } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-stock-delivery-manager',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, TranslateModule],
  templateUrl: './stock-delivery-manager.component.html',
  styleUrl: './stock-delivery-manager.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockDeliveryManagerComponent implements OnInit, OnDestroy {
  private translateService = inject(TranslateService);
  
  deliveryTabs = [
    { label: 'outbound_management.tabs.outbound_notice', value: 'delivery-order' },
    { label: 'outbound_management.tabs.outbound_result', value: 'result' },
  ];
  activeTab = 'delivery-order';
  private navSub?: Subscription;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.updateActiveTabFromRoute();
    this.navSub = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.updateActiveTabFromRoute();
      }
    });
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

  onTabChange(event: { index: number }): void {
    const tab = this.deliveryTabs[event.index];
    this.activeTab = tab.value;
    this.router.navigate([tab.value], { relativeTo: this.route });
  }

  private updateActiveTabFromRoute(): void {
    const child = this.route.firstChild;
    const seg = child?.snapshot.url[0]?.path;
    this.activeTab = seg === 'result' ? 'result' : 'delivery-order';
  }
}
